<template>
  <div class="defib-action">
    <el-switch
      :value="state.isSyncEnabled"
      on-text="sync on"
      off-text="sync off"
      on-color="#62cd63"
      off-color="#f92c2d"
      :width="110"
      class="sync-switch"
      @input="switchSyncEnabled"
    />
    <help-tooltip v-if="syncWarning" type="warning">{{ syncWarning.message }}</help-tooltip>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'defib-action',
  components: {
    HelpTooltip,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        isSyncEnabled: false,
      },
    };
  },
  computed: {
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      return uniqBy(
        get(
          this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
          `caseLogicDescription.${this.control.parent.id}`,
          [],
        ).filter(
          warning => warning.metadata && warning.metadata.scope === 'control',
        ),
        'message',
      );
    },
    syncWarning() {
      return this.warnings.find(
        warning => warning.metadata.componentId === 'SYNC',
      );
    },
  },
  created() {},
  mounted() {
    const data = this.getData(this.ikey);
    this.state.isSyncEnabled = get(data, 'id') === 'SYNC';
    this.update();
  },
  methods: {
    switchSyncEnabled(enabled) {
      this.state.isSyncEnabled = enabled;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'PACING',
        id: this.state.isSyncEnabled ? 'SYNC' : 'DEFIBRILLATION',
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
.defib-action {
  margin-top: 10px;
}
</style>
